import styled from 'styled-components';

const SideTopLogo = styled.img`
  margin-right: auto;
  width: 103px;
  border-style: none;
`;

export default SideTopLogo;
